/**
 * "Merge a URL with a key/value pair, or an object of key/value pairs, and return the new URL."
 *
 * The function takes three arguments:
 *
 * location: The location object from the browser.
 * key: Either a string or an object. If it's a string, it's the key to merge into the URL. If it's an
 * object, it's a set of key/value pairs to merge into the URL.
 * val: The value to merge into the URL. This is only used if key is a string.
 * The function returns a string, which is the new URL
 * @param location - The location object from the react-router-dom library.
 * @param key - The key of the query parameter to add or remove.
 * @param [val=null] - The value to set the key to. If null, the key will be deleted.
 * @returns A function that takes in a location, key, and val.
 */
export const mergeRequestUrl = (location, key, val = null) => {
    const params = new URLSearchParams(location.search);

    if (typeof key === "object") {
        Object.entries(key).forEach(([k, v]) => {
            if (v === null) {
                params.delete(k);
                return;
            }
            params.set(k, v);
        });
    } else {
        if (params.has(key) && params.get(key) === val) {
            params.delete(key);
        } else {
            params.set(key, val);
        }
    }

    return location.pathname + "?" + params.toString();
};
